export default {
  dispenseBaseLookup: [],
  UOMLookup: [],
  dispenseTypeLookup: [],
  packagingLookup: [],
};
